import { suggestPrefixMapping } from '../weldPassPrefixMapper'

/**
 * Suggest canonical WPS pass label for an ALX pass name.
 * Extends the H/R prefix heuristic with Fill N and CAP N matching.
 */
export function suggestAlxPassMapping(
  alxPassName: string,
  canonicalLabels: readonly string[]
): string | null {
  const base = alxPassName.replace(/\s*\((CW|CCW)\)\s*$/, '').trim()
  const labelSet = new Set(canonicalLabels.map((l) => l.toLowerCase()))

  const exact = canonicalLabels.find((l) => l.toLowerCase() === base.toLowerCase())
  if (exact) return exact

  const fillMatch = /^Fill (\d+)$/i.exec(base)
  if (fillMatch) {
    const target = `Fill ${fillMatch[1]}`
    const match = canonicalLabels.find((l) => l.toLowerCase() === target.toLowerCase())
    if (match) return match
    const prefixed = canonicalLabels.find((l) =>
      l.toLowerCase().startsWith(`fill ${fillMatch[1]}`)
    )
    if (prefixed) return prefixed
  }

  const capMatch = /^CAP (\d+)$/i.exec(base)
  if (capMatch) {
    const targets = [`Cap ${capMatch[1]}`, `CAP ${capMatch[1]}`]
    for (const target of targets) {
      const match = canonicalLabels.find((l) => l.toLowerCase() === target.toLowerCase())
      if (match) return match
    }
    const prefixed = canonicalLabels.find((l) =>
      l.toLowerCase().startsWith(`cap ${capMatch[1]}`)
    )
    if (prefixed) return prefixed
  }

  if (base === 'ROOT' || base === 'HOT') {
    const target = base === 'ROOT' ? 'Root' : 'Hot'
    const match = canonicalLabels.find((l) => l.toLowerCase() === target.toLowerCase())
    if (match) return match
  }

  if (base.startsWith('HOT ')) {
    const suffix = base.slice(4)
    const match = canonicalLabels.find(
      (l) => l.toLowerCase().startsWith('hot') && l.toLowerCase().includes(suffix.toLowerCase())
    )
    if (match) return match
  }

  const prefix = suggestPrefixMapping(base, canonicalLabels)
  if (prefix) return prefix

  for (const label of canonicalLabels) {
    if (labelSet.has(base.toLowerCase())) return label
  }

  return null
}
